import React from "react";
import {StyleSheet, Text, View} from "react-native";
import {globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import FastImage from "../../../common/FastImage";
import {Input} from "../../../components/core/Input";

const WalletAddressTextBox = ({respError, control, errors}) => {
  return (
    <View>
      <Input
        name="walletAddress"
        control={control}
        label="Registered USDT Wallet Address*"
        variant={respError ? "error" : "default"}
        size="default"
        placeholder="eg: xgdyt"
        rules={{
          required: "Please enter a valid wallet address",
        }}
        rightElement={
          <FastImage
            style={styles.walletIcon}
            source={{
              uri: "https://testapi.theox.co/v2/assets/icons/BTC.png",
            }}
          />
        }
      />
      {respError && (
        <Text style={respError === true ? globalStyle.errorText : styles.successText}>
          {respError?.val}
        </Text>
      )}
    </View>
  );
};

export default WalletAddressTextBox;

const styles = StyleSheet.create({
  walletIcon: {
    height: 22,
    width: 22,
    marginRight: 10,
  },
  successText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.green,
    marginTop: 4,
  },
});
